
import { Component, Mixins } from "vue-property-decorator";
import { Vector, Rectangle } from "../../../../../../../base/domain/drawing";
import { PrintBehaviorPropertyEditableMixin, LineStylePropertyEditableMixin } from "../../../mixins";
import { default as VectorCoordinatableObjectDrawerBase } from "./VectorCoordinatableObjectDrawerBase.vue";

@Component
export default class LineObjectDrawerBase extends Mixins(VectorCoordinatableObjectDrawerBase, PrintBehaviorPropertyEditableMixin, LineStylePropertyEditableMixin) {
  get lineVector(): Vector {
    const rectangle = Rectangle.from(this.offsetVectorCoordinate);
    return new Vector(
      this.offsetVectorCoordinate.from.subtract(rectangle.topLeft),
      this.offsetVectorCoordinate.to.subtract(rectangle.topLeft));
  }
}
